import API from '../api/PriceApi'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const GET_SCHEDULES_REQUEST = 'priceSchedule/GET_SCHEDULES_REQUEST'
const GET_SCHEDULES_SUCCESS = 'priceSchedule/GET_SCHEDULES_SUCCESS'
const GET_SCHEDULES_FAILURE = 'priceSchedule/GET_SCHEDULES_FAILURE'

const UPDATE_SCHEDULE_REQUEST = 'priceSchedule/UPDATE_SCHEDULE_REQUEST'
const UPDATE_SCHEDULE_SUCCESS = 'priceSchedule/UPDATE_SCHEDULE_SUCCESS'
const UPDATE_SCHEDULE_FAILURE = 'priceSchedule/UPDATE_SCHEDULE_FAILURE'

const CREATE_SCHEDULE_REQUEST = 'priceSchedule/CREATE_SCHEDULE_REQUEST'
const CREATE_SCHEDULE_SUCCESS = 'priceSchedule/CREATE_SCHEDULE_SUCCESS'
const CREATE_SCHEDULE_FAILURE = 'priceSchedule/CREATE_SCHEDULE_FAILURE'

const GET_LOGS_REQUEST = 'priceSchedule/GET_LOGS_REQUEST'
const GET_LOGS_SUCCESS = 'priceSchedule/GET_LOGS_SUCCESS'
const GET_LOGS_FAILURE = 'priceSchedule/GET_LOGS_FAILURE'

const initialState = {
  isLoading: true,
  isSaving: false,
  isLogLoading: true,
  error: {},
  schedules: [],
  logs: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SCHEDULES_REQUEST:
      return { ...state, isLoading: true }
    case GET_SCHEDULES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        schedules: Array.isArray(action.payload) ? action.payload : []
      }
    case GET_SCHEDULES_FAILURE:
      return { ...state, isLoading: false, error: action.error }
    case UPDATE_SCHEDULE_REQUEST:
    case CREATE_SCHEDULE_REQUEST:
      return { ...state, isSaving: true }
    case UPDATE_SCHEDULE_SUCCESS:
    case CREATE_SCHEDULE_SUCCESS:
      return { ...state, isSaving: false }
    case UPDATE_SCHEDULE_FAILURE:
    case CREATE_SCHEDULE_FAILURE:
      return { ...state, isSaving: false, error: action.error }
    case GET_LOGS_REQUEST:
      return { ...state, isLogLoading: true }
    case GET_LOGS_SUCCESS:
      return {
        ...state,
        isLogLoading: false,
        logs: Array.isArray(action.payload) ? action.payload : []
      }
    case GET_LOGS_FAILURE:
      return { ...state, isLogLoading: false, error: action.error }
    default:
      return state
  }
}

export const getSchedules = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_SCHEDULES_REQUEST })
      const response = await API.get(EndPoints.PRICE_SCHEDULE)
      dispatch({
        type: GET_SCHEDULES_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({ type: GET_SCHEDULES_FAILURE, error: err })
    }
  }
}

export const updateSchedule = (priceId, data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: UPDATE_SCHEDULE_REQUEST })
      await API.put(EndPoints.PRICE_SCHEDULE + `/${priceId}`, data)
      dispatch({ type: UPDATE_SCHEDULE_SUCCESS })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({ type: UPDATE_SCHEDULE_FAILURE, error: err })
    }
  }
}

export const createSchedule = (priceId, data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: CREATE_SCHEDULE_REQUEST })
      await API.post(EndPoints.PRICE_SCHEDULE, { ...data, price_id: priceId })
      dispatch({ type: CREATE_SCHEDULE_SUCCESS })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({ type: CREATE_SCHEDULE_FAILURE, error: err })
    }
  }
}

export const getLogs = (limit = 50) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_LOGS_REQUEST })
      const response = await API.get(EndPoints.PRICE_LOG + `?limit=${limit}`)
      dispatch({
        type: GET_LOGS_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({ type: GET_LOGS_FAILURE, error: err })
    }
  }
}
